export default __webpack_public_path__ + "static/media/paul-calendar.2ba9c7c5.svg";